import { getTimeLeft } from '@/lib/utils';
import { getCourseDetails } from '@/screens/courses/courses-details/actions/course-details';
import { produce } from 'immer';
import { create } from 'zustand';
import { CourseActions, CourseData, timeData } from '../type/type';

type CourseStore = CourseData & CourseActions;

export const useCourseStore = create<CourseStore>(set => ({
  courseId: 0,
  chapterId: 0,
  lectureId: 0,
  lectureTitle: '',
  isCompleted: false,
  canSubmitTask: false,
  type: 'video',
  url: null,
  playList: '',
  description: '',
  notes: '',
  loading: true,
  error: null,
  status: '',
  openAccordionList: [],
  timeLeft: {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    timeDifference: 0,
  },

  setData: newData => set(state => ({ ...state, ...newData })),

  fetchPlayList: async slug => {
    set(state => ({ ...state, loading: true }));

    try {
      const data: any = await getCourseDetails(slug);
      const timeleft = calculateTimeLeft(data);
      set(state => ({
        ...state,
        playList: data,
        courseId: data?.id,
        loading: false,
        timeLeft: timeleft,
      }));
    } catch (error: any) {
      set(state => ({ ...state, error: error.message, loading: false }));
    }
  },

  setOpenAccordionList: item => set(state => ({ ...state, openAccordionList: [item] })),

  toggleAccordionList: item =>
    set(
      produce(state => {
        const { openAccordionList } = state;
        const index = openAccordionList.indexOf(item);
        if (index !== -1) {
          state.openAccordionList.splice(index, 1);
        } else {
          state.openAccordionList.push(item);
        }
      })
    ),

  setTimeLeft: (newTime: timeData) =>
    set(state => ({
      timeLeft: { ...state.timeLeft, ...newTime },
    })),
}));

function calculateTimeLeft(data: any) {
  if (!data?.orders?.[0]?.createdAt) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timeDifference: 0,
    };
  }
  const timeleft = getTimeLeft(data.orders[0].createdAt, data.courseSupportDuration);
  return {
    days: timeleft?.days || 0,
    hours: timeleft?.hours || 0,
    minutes: timeleft?.minutes || 0,
    seconds: timeleft?.seconds || 0,
    timeDifference: timeleft?.timeDifference || 0,
  };
}
